import { Microfrontend } from '@thoughtspot/microfrontends';
import { loadMicroFrontendComponent } from './microfrontend-wrapper';
import { initMicroFrontend } from './microfrontends.util';

enum HomeComponents {
    HomePage = 'HomePage',
    LiveboardPage = 'LiveboardPage',
    AnswerPage = 'AnswerPage',
    LearningModuleContainer = 'LearningModuleContainer',
    ObjectTableHeader = 'ObjectTableHeader',
    HomeLeftNavigation = 'HomeLeftNavigation',
    HomeLibraryContainer = 'HomeLibraryContainer'
}

export const HomePage = loadMicroFrontendComponent(
    Microfrontend.HOME,
    HomeComponents.HomePage,
);

export const LiveboardPage = loadMicroFrontendComponent(
    Microfrontend.HOME,
    HomeComponents.LiveboardPage,
);

export const AnswerPage = loadMicroFrontendComponent(
    Microfrontend.HOME,
    HomeComponents.AnswerPage,
);

export const LearningModuleContainer = loadMicroFrontendComponent(
    Microfrontend.HOME,
    HomeComponents.LearningModuleContainer,
);

export const ObjectTableHeader = loadMicroFrontendComponent(
    Microfrontend.HOME,
    HomeComponents.ObjectTableHeader,
);

export const HomeLeftNavigation = loadMicroFrontendComponent(
    Microfrontend.HOME,
    HomeComponents.HomeLeftNavigation,
);

export const HomeLibraryContainer = loadMicroFrontendComponent(
    Microfrontend.HOME,
    HomeComponents.HomeLibraryContainer,
);


export default HomePage;

initMicroFrontend(Microfrontend.HOME);
